import React from 'react';
import PropTypes from 'prop-types';
import StencilFlap from 'pu-react/components/StencilFlap';
import StencilLengthSelect from 'pu-react/components/StencilLengthSelect';
import StencilWidthSelect from 'pu-react/components/StencilWidthSelect';
import StencilThickness from 'pu-react/components/StencilThickness';
import StencilAlignment from 'pu-react/components/StencilAlignment';
import StencilFiducialData from 'pu-react/components/StencilFiducialData';

import PrototypeStencilType from '../PrototypeStencilType';
import ApertureCount from '../ApertureCount';
import { stencilLengthOptions, stencilsWidthOptions } from '../../data/SelectOptions';

const PrototypeSmtStencil = ({ product, onChangeParameter, parameters, reference, validator }) => {
  const groupName = `parameters[${reference + 1}]`
  return (
    <div className="product-parameters row">
      <div className="col-lg-3">
        <PrototypeStencilType
          variants={product.variants}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Stencils Type', parameters.prototype_stencil_type, 'required')} />
      </div>
      <div className="col-lg-3">
        <ApertureCount
          variants={product.variants}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Aperture Count', parameters.aperture_count, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilFlap
          required={true}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Flaps', parameters.flaps, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilAlignment
          required={true}
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Alignment', parameters.alignment, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilLengthSelect
          required={true}
          parameters={parameters}
          options={stencilLengthOptions}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Stencil Length', parameters.stencil_length, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilWidthSelect
          required={true}
          parameters={parameters}
          options={stencilsWidthOptions}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Stencils Width', parameters.stencil_width, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilThickness
          required={true}
          name="stencil_thickness"
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Stencils Thickness', parameters.stencil_thickness, 'required')} />
      </div>
      <div className="col-lg-3">
        <StencilFiducialData
          parameters={parameters}
          onChangeParameter={onChangeParameter}
          groupName={groupName}
          errorMessage={validator.message('Fiducial Data', parameters.fiducial_data, 'required')} />
      </div>
    </div>
  );
}

PrototypeSmtStencil.prototype = {
  product: PropTypes.object.isRequired,
  parameters: PropTypes.object.isRequired,
  reference: PropTypes.number.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
}

export default PrototypeSmtStencil;
